/* eslint-disable */
export default {
  createLog: 'Crear registro',
  creating: 'Creando',
  save: 'Guardar',
  saving: 'Guardando',
  saved: 'Guardado',
  view: 'Ver',
  creatingFailed: 'Se ha producido un error al crear.',
  savingFailed: 'Error al guardar.',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
